export default __webpack_public_path__ + "e7079f4bdd94cc0738b10a5a7598fd45.svg";